import TeamsList from "src/components/compounds/TeamsList/TeamsList";
import { Interstitial } from "../Interstitial";
import Styles from "./TeamsPage.module.scss";
import { generatePath, useNavigate } from "react-router-dom";
import { Text } from "../../atoms/Text/Text";
import { Icon } from "src/components/atoms/Icon/Icon";
import { GridItem } from "src/components/atoms/Grid/GridRow";
import { Grid } from "src/components/atoms/Grid/Grid";
import { TextInput } from "src/components/atoms/TextInput/TextInput";
import cn from "classnames";
import { ROUTES } from "src/utils/constants/routes";
import { useGetMeTeamsGroupedQuery } from "src/state/modules/api";
import PageLoader1 from "src/components/atoms/PageLoader/PageLoader";

const TeamsPage: React.FC = () => {
  const navigator = useNavigate();
  const { data, isLoading } = useGetMeTeamsGroupedQuery(null);

  if (isLoading) return <PageLoader1 />;

  // The search box on Home is a launcher: focusing it sends the user to the
  // full team search on /import with the cursor already in that input.
  const goToImport = () => navigator(generatePath(ROUTES.import));

  const teamListContent =
    data && data.length > 0 ? (
      <TeamsList teams={data} Interstitial={Interstitial} />
    ) : (
      <h2>No Teams Found.</h2>
    );

  return (
    <div className={Styles.teamPageContainer}>
      <Grid className={Styles.teamPageGrid}>
        <GridItem>
          <div className={Styles.teamPageHeader}>
            <Text align={"left"} weight={"xbold"} size={"xlarge"} color={"off-black"}>
              Home
            </Text>
          </div>
          <div className={Styles.wrapper}>
            <div className={Styles.inputWrapper}>
              <div aria-hidden="true" className={Styles.icon}>
                <Icon type={"magnify"} size="small" fill="coolGrey" />
              </div>

              <TextInput
                className={cn(Styles.input)}
                aria-label="Find a Team"
                placeholder="Find a Team"
                readOnly
                onFocus={goToImport}
                onClick={goToImport}
              />
            </div>
          </div>
          {teamListContent}
        </GridItem>
      </Grid>
    </div>
  );
};

export default TeamsPage;
